import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(8)};
  background: ${({ theme }) => theme.background.primary};
  text-align: center;
`;

const Code = styled.p`
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.accent.primary};
  margin: 0 0 ${({ theme }) => theme.spacing(3)} 0;
`;

const Title = styled.h1`
  font-size: clamp(24px, 4vw, 40px);
  font-weight: 700;
  color: ${({ theme }) => theme.font.color.primary};
  margin: 0 0 ${({ theme }) => theme.spacing(3)} 0;
`;

const Sub = styled.p`
  font-size: ${({ theme }) => theme.font.size.md};
  color: ${({ theme }) => theme.font.color.secondary};
  margin: 0 0 ${({ theme }) => theme.spacing(8)} 0;
`;

const HomeLink = styled(Link)`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.accent.primary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

function NotFound() {
  return (
    <Wrapper>
      <Code>404</Code>
      <Title>Page not found</Title>
      <Sub>The page you're looking for doesn't exist or has been moved.</Sub>
      <HomeLink to="/dashboard">Go to dashboard →</HomeLink>
    </Wrapper>
  );
}

export default NotFound;
